import { Link } from 'react-router-dom';
import type { Project } from '../../lib/projects';
import { formatDate } from './ProjectCard';
import { PinButton } from './PinButton';
import { StatusBadge } from './StatusBadge';
import { ProjectThumb } from './ProjectThumb';

export function ProjectRow({
  project,
  onTogglePin,
  pinning = false,
}: {
  project: Project;
  /** Omitted where there is nothing to update, e.g. a read-only listing. */
  onTogglePin?: (project: Project) => void;
  pinning?: boolean;
}) {
  return (
    // The <li> carries the hover treatment so the pin button, which must sit
    // outside the anchor, still reads as part of the same row.
    <li className="flex items-center transition hover:bg-stone-100/70">
      <Link
        to={`/projects/${project.id}`}
        className="flex min-w-0 flex-1 items-center gap-3 px-4 py-2"
      >
        <ProjectThumb project={project} className="h-8 w-8 text-xs" />

        <div className="min-w-0 flex-1">
          <p className="truncate text-sm font-medium text-stone-900">{project.name}</p>
          {project.description ? (
            <p className="truncate text-xs text-stone-500">{project.description}</p>
          ) : null}
        </div>

        {project.tags.length > 0 ? (
          <ul className="hidden shrink-0 gap-1.5 sm:flex">
            {project.tags.slice(0, 3).map((tag) => (
              <li key={tag} className="rounded-full bg-stone-100 px-2 py-0.5 text-xs text-stone-600">
                {tag}
              </li>
            ))}
          </ul>
        ) : null}

        <div className="hidden w-28 shrink-0 text-right text-xs text-stone-500 md:block">
          {formatDate(project.updatedAt)}
        </div>

        <div className="shrink-0">
          <StatusBadge status={project.status} />
        </div>
      </Link>

      {onTogglePin ? (
        <div className="shrink-0 pr-3">
          <PinButton pinned={project.pinned} busy={pinning} onClick={() => onTogglePin(project)} />
        </div>
      ) : null}
    </li>
  );
}
